// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"dc0d430b","564":"0d23833c","676":"5429398c","798":"10683fe5","857":"cb8b2078","932":"c0fbad4a"}[chunkId] + ".chunk.js";
};